<template>
    <div class="col-lg-12">
        <div class="card border-top-0">

            <div class="tab-content">
                <div class="tab-pane fade show active" id="profileTab" role="tabpanel">
                    <div class="card-body personal-info">
                        <form @submit.prevent="submitForm">
                            <div class="mb-4 d-flex align-items-center justify-content-between">
                                <h5 class="fw-bold mb-0 me-4">
                                    <span class="d-block mb-2">Barınak Kartı:</span>
                                    <span class="fs-12 fw-normal text-muted text-truncate-1-line">Barınak kartlarını
                                        buradan ekleyebilirsiniz.</span>
                                </h5>
                                <div class="d-flex gap-2">
                                    <button type="submit" class="btn btn-sm btn-light-brand">Kaydet</button>
                                    <a href="javascript:void(0);" class="btn btn-sm btn-light-brand">Kaydet ve Yeni
                                        Sayfa
                                        Aç</a>
                                </div>
                            </div>
                            <div class="row mb-4 align-items-center">
                                <div class="col-lg-2">
                                    <label class="fw-semibold">Barınak Adı: </label>
                                </div>
                                <div class="col-lg-10">
                                    <div class="input-group">
                                        <input type="text" class="form-control" v-model="shelterName"
                                            placeholder="Barınak Adı">
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-4 align-items-center">
                                <div class="col-lg-2">
                                    <label class="fw-semibold">Barınak Konumu: </label>
                                </div>
                                <div class="col-lg-10">
                                    <div class="input-group">
                                        <input type="text" class="form-control" v-model="shelterLocation"
                                            placeholder="Barınak Konumu">
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-4 align-items-center">
                                <div class="col-lg-2">
                                    <label class="fw-semibold">Açıklama: </label>
                                </div>
                                <div class="col-lg-10">
                                    <div class="input-group">
                                        <input type="text" class="form-control" v-model="shelterDescription"
                                            placeholder="Açıklama">
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-4 align-items-center">
                                <div class="col-lg-2">
                                    <label class="fw-semibold">Bağlı Depo: </label>
                                </div>
                                <div class="col-lg-10">
                                    <div class="input-group">
                                        <select v-model="shelterWarehouse" class="form-control"
                                            data-select2-selector="shelter-warehouse" @click="fetchWarehouse">
                                            <option v-for="item in warehouse" :key="item.id" :value="item.id">
                                                {{ item.name }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Swal from 'sweetalert2';
import dayjs from 'dayjs';
export default {
    name: 'CreateShelter',
    data() {
        return {
            shelterName: "",
            shelterLocation: "",
            shelterDescription: "",
            shelterWarehouse: "",
            warehouse: [],
        }
    },
    async mounted() {
        await this.fetchSpecies();
    },
    methods: {
        async fetchWarehouse() {
            try {
                const response = await this.$axios.get('warehouse/?active=True');
                this.warehouse = response.data;
            } catch (error) {
                Swal.fire('Hata', error, 'error');
            }
        },
        async submitForm() {
            const formData = new FormData();
            formData.append('name', this.shelterName);
            formData.append('location', this.shelterLocation);
            formData.append('description', this.shelterDescription);
            formData.append('warehouse', this.shelterWarehouse);
            console.log(formData);

            try {
                const response = await this.$axios.post('animal_shelter/', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });
                Swal.fire('Başarılı!', 'Kayıt tamamlandı.', 'success');
                this.$router.push({ name: 'Shelters', params: { page: 1 } });
            } catch (error) {
                console.log(error);

                let errorMessage = Object.entries(error.response.data)
                    .map(([key, value]) => `${key}: ${value}`)
                    .join('<br><br>');

                Swal.fire({
                    title: 'Hata!',
                    html: errorMessage,
                    icon: 'error',
                    confirmButtonText: 'Tamam'
                });
            }
        },

    }
}
</script>